import styled, { css } from 'react-emotion';

import { queries } from './mediaQueries';
import theme from './theme';

export const resultItemDetails = css`
	color: #a2a2a2;
	position: relative;

	div:not(:first-child) {
		border-left: 1px solid #eee;
	}
`;

export const resultListContainer = css`
	margin-top: calc(${theme.grid.topAreaHeight} + 12px);

	${queries.xLarge`
		margin-top: 170px;
	`};
	${queries.medium`
		margin-top: 220px;
	`};

	.result-list-container {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.result-list-pagination {
		margin: 40px 0 50px;
	}

	.result-list-info {
		margin: 1rem;
		justify-content: space-between;
	}

	.powered-by {
		margin: 0 20px 20px 0;
		display: none;
		border: 3px solid red;
	}
`;

export const resultCardHeader = css`
	flex-direction: row;
	width: 100%;
	justify-content: space-between;

	${queries.xLarge`
		flex-direction: column;
		width: 100%;

		div {
			justify-content: space-between;
		}
	`};
`;

const ResultItem = styled.div`
	padding: 20px 0;
	margin: 15px;
	padding: 25px;
	border: 1px solid #eee;
	flex-basis: 400px;
	max-width: 400px;
	min-height: 300px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	transition: all 0.3s cubic-bezier(.25,.8,.25,1);
	font-size: 12px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;

	${queries.xxxLarge`
		flex-basis: 350px;
		max-width: 350px;
	`};

	&:hover {
		box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
	}
`;

export default ResultItem;



// WEBPACK FOOTER //
// ./src/styles/ResultItem.js